import _Object$keys from "@babel/runtime-corejs2/core-js/object/keys";
import get from 'lodash/get';
import { createSelector } from 'reselect';
import { selectFromConfig } from '@gandi/redux-config';
import sharingResource from './resource';
export var selectSharing = function selectSharing(state) {
  return state.sharing;
}; // Current sharing

export var selectCurrentId = createSelector(selectSharing, function (sharing) {
  return sharing && sharing.current || '';
});
export var selectCurrent = createSelector(selectSharing, selectCurrentId, function (sharing, id) {
  return get(sharing, ['organizations', id]);
}); // Personal organization

export var selectPersonalId = createSelector(selectSharing, function (sharing) {
  return sharing && sharing.personal || '';
});
export var selectPersonal = createSelector(selectSharing, selectPersonalId, function (sharing, id) {
  return get(sharing, ['organizations', id]);
}); // Select organizations and subset organizations without personal organization.

export var selectOrganizations = createSelector(selectPersonalId, selectSharing, function (id, sharing) {
  return _Object$keys(sharing.organizations).filter(function (key) {
    return key !== id;
  }) // do not include personal organization
  .map(function (key) {
    return sharing.organizations[key];
  });
});
export var selectFilteredOrganizations = createSelector(selectSharing, function (sharing) {
  return _Object$keys(sharing.filteredOrganizations).map(function (key) {
    return sharing.filteredOrganizations[key];
  });
});
export var selectOrganizationsFetching = function selectOrganizationsFetching(state, label) {
  return sharingResource.selectIsFetching(state, label || 'default');
};
export var selectOrganizationsLoaded = function selectOrganizationsLoaded(state, label) {
  return sharingResource.selectIsLoaded(state, label || 'default');
};
export var selectOneOrganization = createSelector(selectSharing, function (_, props) {
  return props;
}, function (sharing, props) {
  var _sharing$organization;

  return (_sharing$organization = sharing.organizations) === null || _sharing$organization === void 0 ? void 0 : _sharing$organization[props.id];
});
export var selectOneOrganizationFetching = function selectOneOrganizationFetching(state, id) {
  return sharingResource.selectIsFetchingOne(state, {
    label: id
  });
};
export var selectOneOrganizationLoaded = function selectOneOrganizationLoaded(state, id) {
  return sharingResource.selectIsLoadedOne(state, {
    label: id
  });
};
export var selectSettingsUrl = createSelector(selectFromConfig('app.layout.urls', {}), selectPersonalId, function (publicUrls, personalId) {
  if (!personalId) {
    return publicUrls.account;
  }

  return "/organizations/".concat(personalId, "/account");
});
export var selectManageOrganizationsUrl = createSelector(selectFromConfig('app.layout.urls', {}), selectCurrent, function (publicUrls, currentOrga) {
  if (!currentOrga) {
    return '/organizations/organizations';
  }

  return "/organizations/".concat(currentOrga.id, "/organizations");
});